import { Theme } from '@mui/material';

declare module '@mui/material/Box' {
  interface BoxPropsVariantOverrides {
    bordered: true;
  }
}

export const MuiBox = {
  styleOverrides: {},
  variants: [
    {
      props: { variant: 'bordered' },
      style: ({ theme }: { theme: Theme }) => ({
        borderRadius: '12px',
        border: '1px solid',
        borderColor: theme.palette.surface.outlineVariant,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
        padding: '16px',

        '&::-webkit-scrollbar': {
          backgroundColor: 'transparent',
        },
      }),
    },
  ],
};
